// extracted by mini-css-extract-plugin
export default {"wrapper":"ZkPBj","wrapperCover":"J6kSy","video":"sfND+","img":"K2vkQ"};